// @ts-nocheck

// Orders with the status "Følg op på senere". A follow-up stays open until the order gets another status.
export const FOLLOW_UP_ORDERS_FILTER = [{ property: 'status', operation: 'equals', value: 'followUp' }];

// The newest "Følg op på senere" entry in the order's status history.
export const getLatestFollowUp = order => [...(order?.statusHistory || [])]
    .filter(change => change.status === 'followUp' && change.followUp)
    .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0];

const startOfDay = (date) => {
    const day = new Date(date);
    day.setHours(0, 0, 0, 0);
    return day.getTime();
};

// 'overdue', 'today', 'upcoming' or 'none' when the follow-up has no date.
export const getDueState = (date, today = new Date()) => {
    if (!date || Number.isNaN(new Date(date).getTime())) return 'none';
    const difference = startOfDay(date) - startOfDay(today);
    if (difference < 0) return 'overdue';
    if (difference === 0) return 'today';
    return 'upcoming';
};

const getCustomerName = (customer = {}) => [customer.firstName, customer.lastName].filter(Boolean).join(' ').trim();

// One row per order that is waiting for a follow-up, earliest date first.
export const getOpenFollowUps = (orders = [], today = new Date()) => orders
    .filter(order => order?.status === 'followUp')
    .map((order) => {
        const change = getLatestFollowUp(order);
        const followUp = change?.followUp || {};
        return {
            orderId: order.orderId,
            orderNumber: order.orderNumber,
            customerName: getCustomerName(order.customer) || order.customer?.email || 'Ukendt kunde',
            customerEmail: order.customer?.email,
            date: followUp.date,
            title: followUp.title,
            notes: followUp.notes,
            // The advisor chosen in the dialog, otherwise the advisor who created the follow-up.
            responsible: followUp.advisor?.userId ? followUp.advisor : change?.changedBy,
            createdBy: change?.changedBy,
            dueState: getDueState(followUp.date, today),
        };
    })
    .sort((a, b) => {
        if (!a.date) return 1;
        if (!b.date) return -1;
        return new Date(a.date) - new Date(b.date);
    });

export const filterFollowUpsForUser = (followUps, userId) => followUps.filter(followUp => followUp.responsible?.userId === userId);

export const countByDueState = followUps => followUps.reduce((counts, followUp) => ({
    ...counts,
    [followUp.dueState]: (counts[followUp.dueState] || 0) + 1,
}), {});
